<div class='row-fluid build-guide-wrapper'>
  <div class="form-group">
    <label for='guide-search'>Guide</label>
    <p>Search for a guide by title, ID or URL</p>
    <select name="guide-search" class='guide-search select2-guides'>
      {{#guide_title}}
        <option value="{{guide_id}}" title="{{guide_title}}" selected>{{guide_title}}</option>
      {{/guide_title}}
    </select>
  </div>

  <div class="form-group">
    <label for='page-search'>Page</label>
    <select name="page-search" class='page-search select2-pages' {{#disabled}}disabled{{/disabled}}>
      {{#page_title}}
        <option value="{{page_id}}" title="{{page_title}}" selected>{{page_title}}</option>
      {{/page_title}}
    </select>
  </div>

  <div class='editor-buttons'>
    <button class='delete-build-guide delete'>Delete</button>
    <button class='cancel-build-guide cancel'>Cancel</button>
    <button class='submit-build-guide save'>Save</button>
  </div>
</div>
